// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
/**
 * 导入总组件
 */
import App from './App';
/**
 * 导入所有的路由组件
 */
import router from './router';

/**
 * 设置为 false 以阻止 vue 在启动时生成生产提示
 * @type {boolean}
 */
Vue.config.productionTip = false;

/**
 * 导入其他需要使用的Vue相关插件
 */
//vuex
import Vuex from 'vuex';
Vue.use(Vuex);
//axios
import axios from 'axios';
//上传插件
import uploader from 'vue-simple-uploader';
Vue.use(uploader);
//打印插件
import Print from 'vue-print-nb'
Vue.use(Print);
//验证
import zh_CN from 'vee-validate/dist/locale/zh_CN';
import VeeValidate from 'vee-validate';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'zh_CN',
});
Vue.use(VeeValidate, {
  i18n,
  i18nRootKey: 'validation',
  dictionary: {
    zh_CN
  }
});
//自定义验证
import {Validator} from 'vee-validate';
//为空提示语句修改
const dictionary = {
  zh_CN: {
    messages: {
      required: function (name) {
        return name+'不能为空!';
      },
      mobile: function (name){
        return name+'必须是11位手机号码!';
      },
      maxL: function (name, args) {
        return name+'超过最大字节长度';
      },
      beforeDate: '{0}必须小于或等于{1}',
      /*function (name1, [n1, n2]) {
      //console.log(n1);
      //console.log(n2);

      // let name2 = name1=="开班时间"?"结业时间":"结束时间";
      return name1+"必须小于或等于"+ n1;
    },*/

      afterDate: function (name1, args) {
        let name2 = name1=="结业时间"?"开班时间":"开始时间";
        return name1+"必须大于或等于"+name2;
      }
    }
  }
};
Validator.localize(dictionary);
//电话验证
const isMobile = {
  validate: function(value, args) {
    return value.length == 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/.test(value)
  }
};
Validator.extend('mobile', isMobile);
//日期之前验证
const isBeforeDate = {
  validate: function (value, args) {
    let date1 = new Date(value);
    let obj = args[1];
    if(obj){
      let data2 = new Date(obj);
      return date1.getTime() <= data2.getTime();
    }else {
      return true;
    }
  }
}
Validator.extend('beforeDate', isBeforeDate);
//日期之后验证
const isAfterDate = {
  validate: function (value, args) {
    let date1 = new Date(value);
    let obj = args[1];
    if(obj){
      let data2 = new Date(obj);
      return date1.getTime() >= data2.getTime();
    }else {
      return true;
    }
  }
}
Validator.extend('afterDate', isAfterDate);

//长度验证
const isMaxLength = {
  validate: function (value, args) {
    let realLength = 0;
    for(let i = 0; i < value.length; i++) {
      let charCode = value.charCodeAt(i);
      if (charCode >= 0 && charCode <= 128)
        realLength += 1;
      else
        realLength += 2;
    }
    return realLength <= parseInt(args[0]);
  }
}
Validator.extend('maxL', isMaxLength);

/**
 * 导入其他需要使用的jQuery插件以及需要的样式文件
 */
//bootstrap
import '../static/bootstrap/js/bootstrap.min.js';
import '../static/bootstrap/css/bootstrap.min.css';
//bootstrap日期选择框
import '../static/bootstrap/datetimepicker/js/bootstrap-datetimepicker.min';
import '../static/bootstrap/datetimepicker/js/bootstrap-datetimepicker.zh-CN';
import '../static/bootstrap/datetimepicker/css/bootstrap-datetimepicker.min.css';
//弹窗
import '../static/flavr/js/flavr.min.js';
import '../static/flavr/js/flavr.override.js';
import '../static/flavr/css/style.css';
import '../static/flavr/css/animate.css';
import '../static/flavr/css/flavr-override.css';
import '../static/flavr/css/flavr.css';
//视频播放插件video.js
import '../static/vide7.1.0/js/videojs-ie8.min';
import '../static/vide7.1.0/js/video.min';
import '../static/vide7.1.0/css/video-js.min.css';

import promiseFinally from 'promise.prototype.finally';
promiseFinally.shim();
/**
 * 静态json文件读取，需把文件放置在src目录下才能访问到（貌似放在static文件夹下时无法正常访问读取）
 */
// import configData from './json/data-test';
import configData from './json/data';
// import configData from './json/data-dev';
import dictionaryData from './json/dictionary';

import VueNativeSock from 'vue-native-websocket';

if(!window.sessionStorage){
  console.error("浏览器不支持sessionStorage技术，刷新界面后需要重新登录");
}
const storage = window.sessionStorage||{};
/**
 * 创建vuex仓库来存储数据
 * @type {Store}
 */
export const store = new Vuex.Store({
  state: {
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false
    },
    //服务地址
    // schoolDomainIp: '',
    // serviceBase: '',
    // serviceBase: '',
    // platSsoManageIp: '',
    // specialFlag: '',
    // leaderUserCode: '',
    // easUserCode: '',
    // teacherClassUserCode: '',
    // teacherUserCode: '',
    // studentUserCode: '',
    //
    // //字典数据
    // dictionaryDataObj: {},
    //
    // //用户登录状态
    // loginUserName: '',
    // userLoginStatus: '',
    // token_type: '',
    // access_token: '',
    // expires_in: 0,
    // refresh_token: '',
    // loginTimeStamp: 0,
    //
    // //用户对象
    // userName: '',
    // userCode: '',
    // studentId: '',
    // photoPath: '',
    // teacherClazzCode:'',
    //
    // //userInfo对象
    // deviceToken: '',
    //
    // //班级详情状态
    // clazzId: '',
    // publishStatus: 0,//0是未发布，1是已发布
    // classStatus: 0,//0是未开班，1是已开班，-1是已结业
    // //
    // classInfoEditFlag: 1,
    // userId:'',
    // //查看信息详情-信息ID
    // msgDetailsId: '',
    //
    // //批改教师参数传递-班级ID，作业ID,班级状态
    // tea_clazzId: '',
    // tea_schoolworkId: '',
    // tea_clazzStatus:'',
    //
    // //考勤管理班级ID、班级名称
    // attendanceClazzId:'',
    // attendanceClazzName:''

  },
  mutations: {
    syncWithConfigData (state) {
      let domain = configData['domain'];
      if(!domain || !domain.toLowerCase().startsWith("http")){
        // let port = window.location.port;
        let protocol = window.location.protocol;
        let host = window.location.host;
        configData['domain'] = protocol + "//" + host + (domain||"");
      }
      configData['domain_websocket'] = configData['domain'].replace("http", "ws");
      for(let key in configData){
        let o = configData[key];
        if(typeof o !== 'function' ){
          switch (key) {
            case 'serviceBase':
              state[key] = configData['domain'] + o;
              break;
            case 'ssoBase':
              state[key] = configData['domain'] + o;
              break;
            case 'websocketBase':
              state[key] = configData['domain_websocket'] + o;
              break;
            default:
              state[key] = o;
          }
        }
      }
    },
    syncWithStorage (state) {
      for(let key in storage){
        let o = storage[key];
        if(typeof o !== 'function' ){
          state[key] = o;
        }
      }
    },
    clearStorageState(state){
      for(let key in storage){
        storage.removeItem(key)
        delete state[key]
      }
    },
    SOCKET_ONOPEN (state, event) {
      Vue.prototype.$socket = event.currentTarget
      state.socket.isConnected = true
      //console.log('SOCKET_ONOPEN')
    },
    SOCKET_ONCLOSE (state, event) {
      state.socket.isConnected = false
      //console.log('SOCKET_ONCLOSE')
    },
    SOCKET_ONERROR (state, event) {
      //console.log('SOCKET_ONERROR')
      console.error(state, event)
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE (state, message) {
      state.socket.message = message
      vue.$emit('SOCKET_ONMESSAGE', message)
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT (state, count) {
      //console.log('SOCKET_RECONNECT')
      console.info(state, count)
    },
    SOCKET_RECONNECT_ERROR (state) {
      //console.log('SOCKET_RECONNECT_ERROR')
      state.socket.reconnectError = true
    },
  },
  actions: {
    /**
     * 更新token
     */
    async updateToken (state) {
      let userLoginStatus = (store.state.userLoginStatus==="true"||store.state.userLoginStatus===true);
      if (userLoginStatus ) {
        // console.info("登录即将超时");
        schoolAxios({
          method: 'post',
          baseURL: store.state.ssoBase,
          url: 'sso/oauth/token',
          data: {
            grant_type: 'refresh_token',
            refresh_token: store.state.refresh_token,
            client_id: 'Spa',
            client_secret: 'Appsecret_password'
          },
        }).then(function (response) {
          let data = response.data
          store.set('token_type', data.token_type)
          store.set('access_token', data.access_token)
          store.set('expires_in', data.expires_in)
          store.set('refresh_token', data.refresh_token)
          let loginTimeStamp = new Date().getTime()
          store.set('loginTimeStamp', loginTimeStamp)
        }).catch(function (error) {
          if (error.response && (error.response.status == 401 || error.response.status == 400)) {
            store.commit('clearStorageState')
            if (vue.$route.name != 'Login') {
              document.querySelector('.modal').modal('hide')
              vue.$router.push({name: 'Login', query: {lastVisitPath: vue.$route.path}})
            }
          }
        })
      }
    },
  }
});
store.commit('syncWithConfigData')
store.commit('syncWithStorage')

Vuex.Store.prototype.set = function(key, value){
  this.state[key] = value;
  storage[key] = value;
}
Vue.use(VueNativeSock, store.state.websocketBase + 'websocket/command/',
  {
    store: store,
    format: 'json',
    connectManually: true,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 3000
  })

/**
 * 路由全局钩子设置访问权限
 */
router.beforeEach(function (to, from, next) {
  //权限管理判断
  if (to.meta.auth) {
    //获取登录状态
    let userLoginStatus = (store.state.userLoginStatus==="true"||store.state.userLoginStatus===true);
    //如果已经登录
    if (userLoginStatus) {
      if(to.meta.owner){
        let flag = -1;
        for (let i = 0; i < to.meta.owner.length; i++){
          flag = store.state.userCode.indexOf(to.meta.owner[i]);
          if(flag != -1){
            break;
          }
        }
        if(flag == -1){
          next({
            path: '/noRight',
          });
        }
      }
      next();
    } else {//如果没有登录，则跳转至登录界面
      next({
        path: '/login',
        query: {lastVisitPath: to.fullPath}//把要跳转的地址作为参数传到下一步
      });
    }
  } else {
    //通过
    next();
  }
});

/**
 * 创建和挂载根实例。记得要通过 router 配置参数注入路由，从而让整个应用都有路由功能
 * @type {CombinedVueInstance<V extends Vue, Object, Object, Object, Record<never, any>>}
 */
const eventHub = new Vue()
const vue = new Vue({
  el: '#app',
  store: store,
  router: router,
  components: {App},
  template: '<App/>',
  provide () {
    return {
      eventHub: eventHub// 定义事件总线
    }
  }
});


/**
 * 创建单点登录Axios实例对象
 * @type {AxiosInstance}
 */
// axios.defaults.withCredentials = true;
export const schoolAxios = axios.create({
  //`method` 是请求的方法
  method: 'post',
  //如果url不是绝对路径，那么会将baseURL和url拼接作为请求的接口地址；用来区分不同环境，建议使用
  baseURL: store.state.serviceBase,
  //请求超时时间（毫秒）
  timeout: 10000,
  //`headers` are custom headers to be sent
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Accept': 'application/json, text/javascript, */*'
  },
  transformRequest: [
    function (data) {
      if(!data || data.constructor == Array){
        return data;
      }
      let ret = '';
      for (let it in data) {
        if (ret != "") {
          ret += '&';
        }
        if(data[it]!==null && data[it]!==undefined){
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]);
        }
      }
      return ret;
    }
  ]
});
/**
 * 创建单点登录Axios的请求拦截器
 */
schoolAxios.interceptors.request.use(
  config => {//这里的config包含每次请求的内容
    config.headers['Authorization'] = store.state.token_type + " " + store.state.access_token;
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
/**
 * 创建单点登录Axios的响应拦截器
 */
schoolAxios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401://返回 401 刷新token， 否则跳转到登录页面
          if(vue.$route.name != "Login"){
            let data = error.response.data;
            if(!data) return;
            let rtnToken = data.error_description;
            let err = data.error;
            if(err = "invalid_token" && rtnToken == store.state.access_token && store.state.refresh_token){
              return async function refreshTokenAndReDo(error) {
                let res = null;
                let config = error.response.config
                await store.dispatch("updateToken").then(async function () {
                  config.headers.Authorization = store.state.token_type + " " + store.state.access_token;
                  res = await axios.request(config)
                });
                return res
              }(error);
            }else{
              // document.querySelector(".modal").modal("hide");
              vue.$router.push({name: 'Login', query: {lastVisitPath: vue.$route.path}});
            }
            break;
          }else{
            if(error.response.data.error_description){
              error.response.data.error_description.showMessage();
              break;
            }
            else
              if(error.response.data.message){
                error.response.data.message.showMessage();
                break;
              }
          }
        case 403://权限不足，提示用户
          // if($(".flavr-container")){
          //   break;
          // }
          "权限不足，请联系管理员。".showMessage();
          break;
        case 500:
        case 400:
          let data = error.response.data;
          if(data && data.message){
            data.message.showMessage();
            break;
          }
        default:
          // if($(".flavr-container")){
          //   break;
          // }
          let errordata = error.response.data;
          if(!errordata || errordata.error != 'invalid_grant')
            "出现故障，请联系管理员。".showMessage();
          break;
      }
    }
    if(error.response){
      return Promise.reject(error.response.data);//返回接口返回的错误信息
    }
    return Promise.reject(error.response);//返回接口返回的错误信息
  },
);






// WEBPACK FOOTER //
// ./src/main.js